import {
    FieldConfig,
    SmartMetadataCard,
} from '@common/components/MetadataCard';
import { useFormattedDate, useFormattedVolume } from '@common/hooks';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelectedClip } from '../hooks/useSelectedClipSelectors';
import { Clip } from '../types';

export const InfoSection = () => {
    const { t } = useTranslation('clipDetails');
    const { selectedClip: metadata, isLoading } = useSelectedClip();

    const { formatVolume } = useFormattedVolume();
    const { formatDate } = useFormattedDate();

    const config: FieldConfig<Clip>[] = useMemo(
        () => [
            { key: 'id' },
            { key: 'clipName' },
            { key: 'title' },
            { key: 'episode' },
            { key: 'customer' },
            { key: 'commercialOffer' },
            { key: 'size', formatter: (val) => formatVolume(val) },
            { key: 'preservationCategory' },
            { key: 'checksumCheck', formatter: (val) => formatDate(val) },
            { key: 'lto' },
            { key: 'container' },
            { key: 'codec' },
            { key: 'bitRate' },
            { key: 'audioMapping' },
            { key: 'created', formatter: (val) => formatDate(val) },
            { key: 'updated', formatter: (val) => formatDate(val) },
            { key: 'status' },
            { key: 'fps' },
            { key: 'resolution' },
            { key: 'mediaObjectType' },
        ],
        [formatDate, formatVolume],
    );

    const resolveLabel = useCallback(
        (key: keyof Clip) => t(`metadata.${key}`),
        [t],
    );

    return (
        <SmartMetadataCard
            title={t('technicalInformation')}
            resolveLabel={resolveLabel}
            isLoading={isLoading}
            source={metadata}
            config={config}
            rows={4}
        />
    );
};
